export const GET_POTENTIAL_USERS = 'PU/GET_POTENTIAL_USERS';
export const GET_POTENTIAL_USERS_FAILURE = 'PU/GET_POTENTIAL_USERS_FAILURE';
export const GET_POTENTIAL_USERS_SUCCESS = 'PU/GET_POTENTIAL_USERS_SUCCESS';
